import _ from "lodash";
import { IPaymentAmount, ISelectedCoupon } from "../models/studentStudent.model";
import { IStudentPayment } from "../models/payments.model";
import { IStudentCoupon } from "../models/coupons2.model";

const usePayment = () => {
  const getPaymentAmount = (
    paymentAmounts: IPaymentAmount[],
    filter: (data: IStudentPayment | IPaymentAmount) => boolean,
  ) => {
    return paymentAmounts
      .filter(filter)
      .filter(({ checked }) => checked)
      .reduce((acc, cur) => acc + cur.amount, 0);
  };

  const getMaxAmount = (baseAmount: number, couponAmount: number) => {
    return baseAmount <= couponAmount ? baseAmount : couponAmount;
  };

  const getCouponDiscount = (
    paymentRecord: IStudentPayment,
    selectedCoupons: ISelectedCoupon[],
  ) => {
    return selectedCoupons
      .filter(item =>
        item.paymentTargetCode === paymentRecord.paymentTargetCode &&
        item.paymentNo === paymentRecord.paymentNo,
      )
      .reduce((acc, cur) => acc + cur.amount, 0);
  };

  const refineFirstPaymentItems = (
    item: IStudentPayment | IPaymentAmount | IStudentCoupon
  ) => {
    return item.paymentTargetCode !== 'ON' && item.paymentTargetCode !== 'AL';
  };

  const refineSecondPaymentItems = (
    item: IStudentPayment | IPaymentAmount | IStudentCoupon,
  ) => {
    return item.paymentTargetCode === 'ON';
  };

  const refineThirdPaymentItems = (
    item: IStudentPayment | IPaymentAmount | IStudentCoupon,
  ) => {
    return item.paymentTargetCode === 'AL';
  };

  const dummyCompletedPaymentItems = (
    item: IStudentPayment | IPaymentAmount | IStudentCoupon,
  ) => {
    throw new Error("잘못된 결제 완료 절차입니다.");
  };

  const handleTossResponse = (tossRes: object) => {
    const result: any = _.cloneDeep(tossRes);
    Object.keys(result).forEach((key: any) => {
      result[key.toLowerCase()] = result[key];
      delete result[key];
    });
    return result;
  };

  return {
    getPaymentAmount,
    getMaxAmount,
    getCouponDiscount,
    refineFirstPaymentItems,
    refineSecondPaymentItems,
    refineThirdPaymentItems,
    dummyCompletedPaymentItems,
    handleTossResponse,
  };
};

export default usePayment;